import { SEND_FAX_FOR_AUCTION_REQUEST } from "core/apollo/graphql";
import {
  CAREPROVIDER_CREATED,
  CAREPROVIDER_INACTIVE,
  SEARCH_TYPE_CARE,
} from "core/consts";
import { mockAuction, mockCareprovider, mockPatient } from "core/mocks";

export const mockSendFax = ({
  fax_type,
  requests,
}: {
  fax_type: number;
  requests: { id: number }[];
}) => [
  {
    mocks: requests.map(({ id }) => ({
      data: { fax: { url: "" }, fax_type, id },
      variables: { auctionRequestId: id, input: { content: "", fax_type } },
    })),
    query: SEND_FAX_FOR_AUCTION_REQUEST,
  },
];

export const careprovider = mockCareprovider({ id: 1 });

export const auctionSend = {
  ...mockAuction({ id: 10, search_type: SEARCH_TYPE_CARE }),
  winner: {
    careprovider: {
      ...careprovider,
      fax_number: "02532456",
      receive_fax: true,
      status: CAREPROVIDER_INACTIVE,
    },
  },
};

export const auctionDontSend = {
  ...mockAuction({ id: 11, search_type: SEARCH_TYPE_CARE }),
  winner: {
    careprovider: {
      ...careprovider,
      fax_number: "02532456",
      receive_fax: false,
      status: CAREPROVIDER_INACTIVE,
    },
  },
};

export const patient = mockPatient({ id: 12 });

export const sendFax1 = {
  __typename: "AuctionRequest",
  auction: auctionSend,
  careprovider: {
    ...careprovider,
    fax_number: "02532456",
    receive_fax: true,
    status: CAREPROVIDER_INACTIVE,
  },
  fax_sent: true,
  id: 1,
};

export const doNotSendFax2 = {
  __typename: "AuctionRequest",
  auction: auctionSend,
  careprovider: {
    ...careprovider,
    fax_number: "02532456",
    receive_fax: true,
    status: CAREPROVIDER_INACTIVE,
  },
  fax_sent: false,
  id: 2,
  patient,
};
export const sendFax3 = {
  __typename: "AuctionRequest",
  auction: auctionSend,
  careprovider: {
    ...careprovider,
    fax_number: "02532456",
    receive_fax: true,
    status: CAREPROVIDER_CREATED,
  },
  fax_sent: false,
  id: 3,
  patient,
};

export const sendFax4 = {
  __typename: "AuctionRequest",
  auction: auctionSend,
  careprovider: {
    ...careprovider,
    fax_number: "02532456",
    receive_fax: true,
    status: CAREPROVIDER_INACTIVE,
  },
  fax_sent: false,
  id: 4,
  patient,
};

export const dontSendFax4 = {
  __typename: "AuctionRequest",
  auction: auctionSend,
  careprovider: {
    ...careprovider,
    fax_number: "02532456",
    receive_fax: false,
    status: CAREPROVIDER_INACTIVE,
  },
  fax_sent: false,
  id: 5,
  patient,
};
